import dbList from "../DBList.json";
import fetchWithTimeout from "./fetchWithTimeout";

const {
    api_server,
    company_config
} = dbList.server;

export async function FetchCompanyConf() {
    const httpRes = await fetchWithTimeout(`${api_server}${company_config}`, {
        method: "GET",
        mode: "cors",
        credentials: "include",
        headers: {
            "accept": "*/*"
        }
    });

    if (httpRes.status === 401) {
        // logout user
        throw {
            status: httpRes.status,
            message: await httpRes.text()
        };
    } else if (httpRes.status !== 200) {
        throw {
            status: httpRes.status,
            message: await httpRes.text()
        };
    }

    const result = await httpRes.json();

    if (result.status !== undefined && result.message !== undefined) {
        throw {
            status: 200,
            message: result.message
        };
    }

    return result;
}

export async function GetConfig(AComp) {
    const {
        companyName,
        productID
    } = AComp;

    const httpRes = await fetchWithTimeout(`${api_server}${company_config}/get/${companyName}/${productID}`, {
        method: "GET",
        mode: "cors",
        credentials: "include",
        headers: { "accept": "*/*" }
    });

    if (httpRes.status === 401) {
        // logout user
        throw {
            status: httpRes.status,
            message: await httpRes.text()
        };
    } else if (httpRes.status !== 200) {
        throw {
            status: httpRes.status,
            message: await httpRes.text()
        };
    }

    const result = await httpRes.json();

    if (result.status !== undefined && result.message !== undefined) {
        throw {
            status: 200,
            message: result.message
        };
    }

    return result;
}

export async function SaveConfig(ACompConf) {
    const httpRes = await fetchWithTimeout(`${api_server}${company_config}`, {
        method: "POST",
        mode: "cors",
        credentials: "include",
        headers: { "accept": "*/*", "content-type": "application/json" },
        body: JSON.stringify(ACompConf)
    });

    if (httpRes.status === 401) {
        // logout user
        throw {
            status: httpRes.status,
            message: await httpRes.text()
        };
    } else if (httpRes.status !== 200) {
        throw {
            status: httpRes.status,
            message: await httpRes.text()
        };
    }

    const result = await httpRes.json();

    if (result.status !== undefined && result.message !== undefined) {
        throw {
            status: 200,
            message: result.message
        };
    }

    return result;
}
